import { Component } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { BusyBarComponent } from '@busy-bar/public-api';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, BusyBarComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {}
